import { useState } from "react";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { Button } from "components/DesignSystem/Button/Button";
import { EditPencil } from "components/icons/EditPencil";

const REVIEW_EDITOR_TOGGLE_VALUE = {
  PREVIEW: "preview",
  EDITOR: "editor",
} as const;

type ReviewEditorToggleProps = {
  isEditable: boolean;
  isPublished: boolean;
  onPreview: () => void;
  onEdit: () => void;
};

export const ReviewEditorToggle = ({
  isEditable,
  isPublished,
  onPreview,
  onEdit,
}: ReviewEditorToggleProps) => {
  const [hasClickedEdit, setHasClickedEdit] = useState(false);
  const isToggleRevealed = isEditable || hasClickedEdit;

  const handleValueChange = (value: string) => {
    if (value === REVIEW_EDITOR_TOGGLE_VALUE.EDITOR) {
      onEdit();
      return;
    }

    if (value === REVIEW_EDITOR_TOGGLE_VALUE.PREVIEW) {
      onPreview();
    }
  };

  const handleRevealToggle = () => {
    setHasClickedEdit(true);
    onEdit();
  };

  if (isPublished && !isToggleRevealed) {
    return (
      <Button
        type="button"
        customType="secondary"
        size="small"
        leftIcon={<EditPencil />}
        onClick={handleRevealToggle}
      >
        Edit template
      </Button>
    );
  }

  return (
    <ToggleGroup
      size="small"
      value={
        isEditable
          ? REVIEW_EDITOR_TOGGLE_VALUE.EDITOR
          : REVIEW_EDITOR_TOGGLE_VALUE.PREVIEW
      }
      onValueChange={handleValueChange}
    >
      <ToggleGroupItem value={REVIEW_EDITOR_TOGGLE_VALUE.EDITOR}>
        Editor
      </ToggleGroupItem>
      <ToggleGroupItem value={REVIEW_EDITOR_TOGGLE_VALUE.PREVIEW}>
        Preview
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
